import { ReactNode, useState } from 'react';
import { useUnit } from 'effector-react';
import classNames from 'classnames';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { $currentWorkspace } from '@nx-frontend/shared/store/current-workspace';

export enum SIDEBAR_SECTION_TYPE {
  INTERNAL_SPACE = 'internal-space',
  CLIENT_PORTAL = 'client-portal',
}

interface SidebarSectionProps {
  title: string;
  type: SIDEBAR_SECTION_TYPE;
  children: ReactNode;
}

export function SidebarSection({ title, type, children }: SidebarSectionProps) {
  const [currentWorkspace] = useUnit([$currentWorkspace]);
  const [isOpened, setIsOpened] = useState(() => {
    return getSectionIsOpened(currentWorkspace.globalId, type);
  });

  const handleSetIsOpened = () => {
    const value = !isOpened;
    localStorage.setItem(`sidebar-section-${type}-${currentWorkspace.globalId}`, value ? 'true' : 'false');
    setIsOpened(value);
  };

  return (
    <>
      <div className="py-4" data-cy={`sidebar-${type}-section`}>
        <div className="flex items-center gap-3 cursor-pointer" onClick={handleSetIsOpened}>
          <div>
            <Icon
              className={classNames('w-3 h-3', {
                '-rotate-90': !isOpened,
              })}
              icon={IconsMap.ARROW_DOWN}
            />
          </div>
          <div className="text-[10px] uppercase">{title}</div>
        </div>
        {isOpened && <div className="pt-4">{children}</div>}
      </div>
      <div className="w-full h-[1px] bg-neutral-200"></div>
    </>
  );
}

function getSectionIsOpened(workspaceId: string, sectionType: SIDEBAR_SECTION_TYPE): boolean {
  if (typeof window === 'undefined') return false;
  const value = localStorage.getItem(`sidebar-section-${sectionType}-${workspaceId}`);
  if (!value) {
    return true;
  }

  return value === 'true';
}
